import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import axios from 'src/lib/axios';
import { validationMessagesMap } from 'src/utils/messages';
import { formatResourcePath } from 'src/utils/regex';

import type { MutationConfig } from 'src/lib/react-query';

const RESOURCE = '/reset-password/';

const formSchema = z
    .object({
        password: z
            .string()
            .regex(new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_-])[a-zA-Z\d@$!%*?&_-]{8,}$/), {
                message: validationMessagesMap.validationErrorPassword,
            }),
        confirm_password: z.string(),
    }) // Confirm passwords match
    .refine(({ confirm_password, password }) => confirm_password === password, {
        message: validationMessagesMap.validationErrorConfirmPassword,
        path: ['confirm_password'],
    });
type FormSchemaValues = z.infer<typeof formSchema>;

interface DTO extends Omit<FormSchemaValues, 'confirm_password'> {
    token?: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = (data: DTO): Promise<null> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as RESET_PASSWORD_RESOURCE, formSchema as resetPasswordSchema, useMutationHook as useResetPassword };
export type { DTO as ResetPasswordDTO, FormSchemaValues as ResetPasswordPayload };
